import React from 'react';
import { SelectorComponent } from '@helpers/Components/selectorComponent';
import { GetColumnClassName } from '@helpers/Components/getColumnClassName';
import { useMaster } from '../../../utility/hooks/useMaster';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const CardInterpreter = (props) => {
  const {
    collection = null,
    card,
    exceptions,
    position = null,
    master,
    title,
  } = props;
  const { form } = useSelector((state) => state);
  const { validateMaster } = useMaster(collection, form, position === null);
  const pathname = useLocation().pathname;
  const isAdd = pathname.slice(-3) === 'add';

  return (
    <>
      {card?.map((e, index) => {
        if (exceptions?.includes(e.name)) return;
        const Component = SelectorComponent(e);
        const finalCollection = [...collection];
        if (Number.isInteger(position) && !finalCollection.includes(position))
          finalCollection.push(position);
        if (!!e.collection && !finalCollection.includes(...e.collection))
          finalCollection.push(...e.collection);
        if (Component) {
          return (
            <Component
              {...e}
              key={`${index}-${e.name}_${collection.join('_')}_${position}`}
              collection={finalCollection}
              position={position}
              containerClassname={`${
                e.containerClassname || 'mt-1'
              } ${GetColumnClassName(e.col)} 
                            ${
                              (!!master || !!e.condition) &&
                              validateMaster(master || e?.condition) === false
                                ? 'd-none'
                                : ''
                            }`}
            />
          );
        }
        return (
          <div
            key={`${index}`}
            className={`${GetColumnClassName(e.col)} d-block`}
          ></div>
        );
      })}
    </>
  );
};
